import { Account } from './account';

export enum FollowStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export type AccountFollow = Pick<Account, 'nickname' | 'imageUrl'> & {
  id: string;
  peerId: string;
  readableId: string;
  followedId: string;
  followingId: string;
  status: FollowStatus;
  approve?: boolean;
};
